var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    option: true,
    pointer: true,
    selected: _vm.selected,
    focused: _vm.focused,
  },on:{"click":_vm.$listeners.click,"mouseenter":_vm.$listeners.hover,"mousedown":function($event){$event.preventDefault();}}},[_c('span',{staticClass:"label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }